const ClientCatalogModel = {};

ClientCatalogModel.BG = {
  SKIP: 0,
  NEUTRAL: 1,
  DEFAULT: 2,
  CUSTOM: 3,
};

export default ClientCatalogModel;
